import { Component, forwardRef } from '@angular/core';
import { FormGroup, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseFormComponent } from 'src/app/widgets/global/BaseFormComponent';
import { PhoneAreaCodeValidator } from 'src/app/validators/phone-area-code-validator'
import { UrlValidator } from 'src/app/validators/url-validator'
import { PatternValidator } from '../../global/Validators';

@Component({
  standalone: false,
  selector: 'app-booking-form',
  templateUrl: './booking-form.component.html',
  styleUrls: ['./booking-form.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => BookingFormComponent),
    multi: true
  }]
})
export class BookingFormComponent extends BaseFormComponent {

  constructor(private phoneAreaCodeValidator: PhoneAreaCodeValidator, private urlValidator: UrlValidator) {
    super();

    this.form = new FormGroup({
      bookingWebsite: new FormControl('', [
        PatternValidator.url(),
        this.urlValidator.validateUrl()
      ]),
      bookingPhone: new FormControl('', [
        PatternValidator.phone(),
        this.phoneAreaCodeValidator.validateAreaCode()
      ])
    });
    this.onValueChanged(p => {
      this.setValues(p.bookingWebsite as string, p.bookingPhone as string);
    });

    this.form.valueChanges.subscribe(values => {
      this.value.bookingWebsite = values.bookingWebsite;
      this.value.bookingPhone = values.bookingPhone;
    });
  }


  setValues(website: string, phone: string) {
    this.form.get('bookingWebsite').setValue(website);

    // sets the default value for phone field
    if (phone)
      this.form.get('bookingPhone').setValue(phone);
    // else
    //   this.form.get('bookingPhone').setValue("+353");
  }
}
